export enum NotificationCategory {
  balance = 'balance',
  bonus = 'bonus',
  account = 'account',
  error = 'error',
  game = 'game',
}
